import React, { useEffect, useState } from 'react'

import { CalendarToday } from '@mui/icons-material'
import { CheckBox, Grid, Input, Row, SimpleCollapse } from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { useLoading, useModal, useMovement } from 'hooks'
import { Entity, IGetContratoId } from 'pages/Supplier/MovMensal/types'
import { MovimentacaoMensalServices } from 'services/Supplier/MovMensal'
import { SPACING, FORMAT } from 'utils'

import ModalContratos from './components/ModalContratos/ModalContratos'

interface ICompetenciaAtualProps {
  getMovData: (_type?: 'flComMob') => void
  getMovDataSemMobilizacao: () => void
  isRequest: boolean;
  consolidacaoFechada: boolean; // Adicione esta prop
}

const CompetenciaAtual: React.FC<ICompetenciaAtualProps> = ({
  getMovData,
  getMovDataSemMobilizacao,
  isRequest,
  consolidacaoFechada // Adicione esta prop
}) => {
  const {
    selectedMovement,
    handleError,
    handleChangeMobilizacao,
    dataAtuacaoInvalida,
    setMovState,
    movState,
    competenciaSelecionada,
    setBlockVerifyIndividual,
    handleBlock,
    cdContratoCompartilhado
  } = useMovement()

  const { showModal } = useModal()
  const { setLoading } = useLoading()

  const [showModalContratos, setShowModalContratos] = useState<boolean>(false)
  const [cdContrato, setCdContrato] = useState<string>('')
  const [contratosId, setContratosId] = useState<IGetContratoId[] | []>([])

  useEffect(() => {
    setCdContrato(cdContratoCompartilhado);
  }, [cdContratoCompartilhado]);

  const handleCdContrato = (event) => {
    setCdContrato(event.target.value)
  }

  const buscaContratos = async () => {
    try {
      setLoading('loading')
      if (cdContrato === selectedMovement.cdContrato) {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            'Impossível compartilhar do mesmo contrato atual.',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })
        return
      }
      const response = await MovimentacaoMensalServices().getContratosId(
        competenciaSelecionada,
        cdContrato,
        selectedMovement.fornecedorId,
        selectedMovement.cdContrato
      )
      if (response.data.sucesso == false && response.data.tipo == "COMPARTILHANDO") {

        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            response.data.mensagem,
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })

        getMovData()
        setMovState((prevState) => ({
          ...prevState,
          flStatusMobilizacao: '1'
        }))
        return;
      }

      setLoading('idle')
      setContratosId(response.data.entity)
      setShowModalContratos(true)

    } catch (error: any) {
      handleError(error)
    }
  }

  const handleBuscaCompartilhado = async (idContrato: number) => {
    handleBlock(true, 'visaoTotal')

    //TODO
    try {
      setLoading('loading')


      const responseMovimentacao =
        await MovimentacaoMensalServices().getMovimentacaoCompartilhada(
          idContrato,
          competenciaSelecionada,
          selectedMovement.contratoId
        )
      if (
        responseMovimentacao.status !== 200 ||
        !responseMovimentacao.data.sucesso
      )
        throw new Error(
          responseMovimentacao.data.mensagem ||
          'Não foi possivel obter dados da movimentação'
        )
      if (
        responseMovimentacao.data.sucesso &&
        responseMovimentacao.data.entity == null
      ) {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            'Este contrato não possui competência atual para compartilhar.',
          txtButtonConfirm: 'Fechar',
          type: 'alert'
        })

        return
      }

      const compAtualModify = responseMovimentacao.data.entity?.compAtual.map(
        (efetivo: Entity) => ({
          ...efetivo,
          cdStatus: 'COMPARTILHADO',
          cdCategoria: efetivo.cdCategoria?.trim(),
          cdNacionalidade: efetivo.cdNacionalidade?.trim(),
          cdTipoEfetivo: efetivo.cdTipoEfetivo?.trim()
        })
      )

      setMovState((prevState) => ({
        ...prevState,
        compAnterior: responseMovimentacao.data.entity.compAnterior,
        compAtual: compAtualModify,
        visaoTotal: {
          ...responseMovimentacao.data.entity.visaoTotal,
          contratoCompartilhadoId: responseMovimentacao.data.entity.contratoId,
          qtNeAnterior: prevState?.visaoTotal?.qtNeAnterior
        }
      })) // Seta a movimentação mensal
      // handleEnvioVisaoIndividual(responseMovimentacao.data.entity)
      setBlockVerifyIndividual(false)
      handleBlock(false, 'visaoIndividual')
      handleChangeMobilizacao('flCompartilhado')
      setLoading('idle')
    } catch (error: any) {
      handleError(error)
    }
  }

  const handlePrepareDataWithoutMobilization = (): void => {
    handleBlock(true, 'visaoIndividual')
    handleBlock(true, 'visaoTotal')

    setMovState((prevState) => ({
      ...prevState,
      compAnterior: prevState.compAnterior,
      visaoTotal: null,
      compAtual: []
    }))

    // Esse timeout serve para que os dados sejam atualizados em tela, pois o componente só da update nos dados após
    // abrir o collapse manualmente.
    setTimeout(() => {
      handleBlock(false, 'visaoIndividual')
      handleBlock(false, 'visaoTotal')
    }, 500)
  }

  //Crie uma variável para determinar se os campos devem ser desabilitados
  const isFieldsDisabled = isRequest || consolidacaoFechada || dataAtuacaoInvalida;

  return (
    <>
      <SimpleCollapse
        title={
          selectedMovement?.flCompAtual
            ? 'MOVIMENTAÇÃO MENSAL ( COMPETÊNCIA ATUAL )'
            : 'MOVIMENTAÇÃO MENSAL'
        }
      >
        <Row alignItems="center">
          <Input
            value={FORMAT.competencia(selectedMovement?.mesAno)}
            label="Movimentação (Mês/Ano)"
            placeholder="mm/aaaa"
            disabled
            width="150px"
            inputIcon={<CalendarToday />}
          />
          <Input
            value={selectedMovement?.nmEmpresaFornecedor || ''}
            formValue="nmFornecedor"
            label="Nome Fornecedor"
            placeholder="Nome Completo"
            marginLeft={SPACING.spacing20}
            marginRight={SPACING.spacing20}
            width="316px"
            disabled
          />

          <CheckBox
            label="Sem Mobilização"
            checked={movState?.flStatusMobilizacao === '0'}
            name="flSemMob"
            onChange={
              dataAtuacaoInvalida
                ? null
                : () => {
                  handleChangeMobilizacao('flSemMob')
                  handlePrepareDataWithoutMobilization();
                  getMovDataSemMobilizacao();
                }
            }
            disabled={isFieldsDisabled} //Use a nova variável
          />
          <CheckBox
            checked={movState?.flStatusMobilizacao === '1'}
            label="Com Mobilização"
            marginLeft={SPACING.spacing15}
            marginRight={SPACING.spacing15}
            name="flComMob"
            onChange={
              dataAtuacaoInvalida
                ? null
                : () => {
                  setMovState((prevState) => ({
                    ...prevState,
                    flStatusMobilizacao: '1'
                  }))
                  getMovData('flComMob')
                }
            }
            disabled={isFieldsDisabled} //Use a nova variável
          />
          <CheckBox
            label="Somente Compartilhado"
            checked={movState?.flStatusMobilizacao === '2'}
            name="flCompartilhado"
            onChange={
              dataAtuacaoInvalida
                ? null
                : () => {
                  handleChangeMobilizacao('flCompartilhado')
                  handleBlock(true, 'visaoIndividual')
                  handleBlock(true, 'visaoTotal')
                }
            }
            disabled={isFieldsDisabled} //Use a nova variável
          />
        </Row>
        <Grid gridCols="180px 360px 130px 380px " margin="2rem 0 0 0">
          <Input
            label="Nº do Contrato Principal"
            placeholder="Nº"
            value={selectedMovement?.cdContratoPrincipal}
            formValue="cdContratoPrincipalId"
            disabled
          />
          <Input
            value={selectedMovement?.nmEmpresaFornecedorPrincipal}
            label="Nome do Fornecedor Principal"
            placeholder="Nome Completo"
            marginLeft={SPACING.spacing15}
            marginRight={SPACING.spacing15}
            width="316px"
            formValue="nmFornecedorPrincipal"
            disabled
          />
          <div />
          {movState.flStatusMobilizacao === '2' && (
            <Input
              label="Número do Contrato"
              marginLeft={SPACING.spacing200}
              name="contratoId"
              onChange={handleCdContrato}
              value={cdContrato}
              inputIcon={<MagnifyingGlassIcon />}
              onClickIcon={buscaContratos}
            />
          )}
        </Grid>
      </SimpleCollapse>
      {!!showModalContratos && (
        <ModalContratos
          showModal={showModalContratos}
          toggleModal={() => setShowModalContratos(false)}
          selectContract={(id, cdContrato) => {
            setShowModalContratos(false)
            handleBuscaCompartilhado(id)
            setCdContrato(cdContrato)
          }}
          listaContratos={contratosId}
        />
      )}
    </>
  )
}

export default CompetenciaAtual